import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProjectProvider } from "@/context/ProjectContext";
import AuthCallback from "@/components/AuthCallback";
import RequireAuth from "@/components/RequireAuth";
import Hub from "@/pages/Hub";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminProjects from "@/pages/admin/AdminProjects";
import Resources from "@/pages/admin/Resources";
import Contacts from "@/pages/admin/Contacts";
import CompanySettings from "@/pages/admin/CompanySettings";
import ModelHome from "@/pages/admin/ModelHome";
import AdminDesigns from "@/pages/admin/AdminDesigns";
import ProjectWorkspace from "@/pages/admin/ProjectWorkspace";
import DrawingEditor from "@/pages/admin/DrawingEditor";
import PortalHome from "@/pages/portal/PortalHome";
import PortalProject from "@/pages/portal/PortalProject";
import Login from "@/pages/Login";
import AcceptInvitation from "@/pages/AcceptInvitation";
import WelcomeGuide from "@/components/WelcomeGuide";
import VersionWatcher from "@/components/VersionWatcher";
import InactivityLogout from "@/components/InactivityLogout";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Hub />} />
        <Route path="/entrar" element={<Login />} />
        <Route path="/invitacion/:token" element={<AcceptInvitation />} />
        <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
          <Route index element={<AdminProjects />} />
          <Route path="recursos" element={<Resources />} />
          <Route path="vivienda-modelo" element={<ModelHome />} />
          <Route path="disenos" element={<AdminDesigns />} />
          <Route path="crm" element={<Contacts />} />
          <Route path="empresa" element={<CompanySettings />} />
        </Route>
        <Route path="/admin/proyectos/:projectId" element={<RequireAuth><ProjectWorkspace /></RequireAuth>} />
        <Route path="/admin/proyectos/:projectId/disenos/:designId/dibujo/:drawingId" element={<RequireAuth><DrawingEditor /></RequireAuth>} />
        <Route path="/portal/:role" element={<RequireAuth><PortalHome /></RequireAuth>} />
        <Route path="/portal/:role/:projectId" element={<RequireAuth><PortalProject /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <WelcomeGuide />
      <VersionWatcher />
      <InactivityLogout />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ProjectProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </ProjectProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
